import wordmark from '../assets/wordmark-ink.png';

/** Veerenstael wordmark (ink tone). Gelijk aan Wagenpark — verandert daar het
 *  merk, dan hier ook. */
export function Logo({ height = 28 }: { height?: number }) {
  return (
    <img
      src={wordmark}
      alt="Veerenstael"
      height={height}
      style={{ display: 'block', height, width: 'auto' }}
    />
  );
}
